import { Flex } from '@components';
import { styled } from '@mui/material';

export const InactiveContainer = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  gap: theme.spacing(8),
  padding: theme.spacing(9),
  borderRadius: theme.spacing(6),
  flexDirection: 'column',
}));
